import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Input, message, Skeleton, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { FaListUl, FaLockOpen, FaShare, FaUserEdit } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { GiReceiveMoney } from "react-icons/gi";
import { IoIosNotifications } from "react-icons/io";
import { LuIndianRupee } from "react-icons/lu";
import { MdEdit } from "react-icons/md";
import { MdDeleteForever } from "react-icons/md";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import PostApiCall from "../../Helper/PostApi";
import ProductCard from "../ProductCard/ProductCard";
import "./CustomerProfilePage.css";
import ProductCard1 from "../ProductCard/ProductCard1";
import { store } from "../../Helper/Context/Store";
import CustomerOrderList from "./CustomerOrderList";
import { Modal, Offcanvas } from "react-bootstrap";
import AddressBookForm from "../Address/AddressBookForm";
import EditProfile from "./EditProfile";
import LogoutModal from "../Login/LogoutModal";
import ChangePassword from "../Login/ChangePassword";
import Notiflix from "notiflix";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GetSeoData from "../../Helper/GetSeoData";
import NoAddress from "../../assets/img/home.png";
export default function CustomerProfilePage() {
  const [apiData, setApiData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const { cartItems } = useContext(store);
  const { totalOrders, setcart, setLoggedIn, setcartamount } =
    useContext(store);
  const [addressData, setAddressData] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [tempAddData, setTempAddData] = useState([]);
  const [editCustomerData, setEditCustomerData] = useState(false);
  const [tempCustomerData, setTempCustomerData] = useState([]);
  const [canLogout, setCanLogout] = useState(false);
  const [openChangePwd, setOpenChangePwd] = useState(false);
  const [showDeleteAdd, setShowDeleteAdd] = useState(false);
  const [addToDelete, setAddToDelete] = useState({});


  const history = useHistory();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    GetProductVertical();
    getCustomerdata();
    getCustomerAddress();
  }, []);

  useEffect(() => {
    if (showCanvas != true) {
      getCustomerAddress();
    }
  }, [showCanvas]);

  const getCustomerdata = () => {
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);
    PostApiCall.postRequest(
      {
        WhereClause: `where fld_customer_id=${CustomerDetails[0].fld_customerid}`,
      },
      "Get_customerData_by_id"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          setCustomerData(obj.data);
        }
      })
    );
  };
  const GetProductVertical = () => {
    PostApiCall.postRequest(
      {
        stateid: null,
      },
      "Get_All_Items"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setApiData(obj1.data.filter((item) => item.fld_status === "Active"));
        }
      })
    );
  };
  const getCustomerAddress = () => {
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);
    PostApiCall.postRequest(
      {
        whereClause: `where fld_customerid=${CustomerDetails[0].fld_customerid}`,
      },
      "GetCustomerAddress"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          setAddressData(obj.data);
        }
      })
    );
  };
  const handleToggleCanvas = () => {
    setShowCanvas(false);
    setTempAddData([]);
  };

  const handleToggleCustomerProfile = () => {
    setEditCustomerData(false);
  };

  const onLogout = () => {
    Notiflix.Loading.circle();
    if (localStorage.getItem("CustomerData") !== null) {
      localStorage.removeItem("CustomerData");
      localStorage.removeItem("OrderData");
      setcart(0);
      setcartamount(0);
      history.push("/");
      setLoggedIn(false);
      setCanLogout(false);
      Notiflix.Loading.remove();
    } else {
      Notiflix.Notify.failure("Something went wrong");
    }
  };
  const handleTogglePwdModal = () => {
    setOpenChangePwd(false);
  };
  const handleToggleLogout = () => {
    setCanLogout(false);
  };
  const hideDeleteAdd = () => {
    setShowDeleteAdd(false);
  }
  const showDeleteModal = (data) => {
    setShowDeleteAdd(true)
    setAddToDelete(data)
  }
  const handleDeleteAdd = () => {

    Notiflix.Loading.dots("");

    // Retrieve customer data from local storage
    var customer = localStorage.getItem("CustomerData");
    var CustomerDetails = JSON.parse(customer);

    // Make the delete request
    PostApiCall.postRequest(
      {
        CUSTOMERID: CustomerDetails[0].fld_customerid,
        addressid: addToDelete.fld_address_id,
        title: addToDelete.fld_address_type,
        name: addToDelete.fld_contact_name,
        mobileNo: addToDelete.fld_contact_number,
        area: addToDelete.fld_address_2,
        flatno: addToDelete.fld_address_1,
        landmark: addToDelete.fld_landmark,
        country: addToDelete.Country,
        state: addToDelete.State,
        city: addToDelete.City,
        pincode: addToDelete.fld_pincode,
        action: "DELETE",
      },
      "AddCustomerAddress"
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status === 200 || results.status === 201) {
          // Fetch updated address list
          PostApiCall.postRequest(
            {
              whereClause: `where fld_customerid=${CustomerDetails[0].fld_customerid}`,
            },
            "GetCustomerAddress"
          ).then((results) =>
            results.json().then((obj) => {
              if (results.status === 200 || results.status === 201) {
                setAddressData(obj.data);
                Notiflix.Notify.success("Address Successfully Deleted.");
                setShowDeleteAdd(false);
                Notiflix.Loading.remove();
              }
            })
          );
        }
      })
    );
  }

  return (
    <>
      <section className="section-spacing-x section-spacing-x-mobile py-4">
        <GetSeoData type="Customerprofile" id={null} />

        <ChangePassword
          isOpen={openChangePwd}
          handdleToggleModal={handleTogglePwdModal}
        />
        <LogoutModal
          show={canLogout}
          onHide={handleToggleLogout}
          onLogout={onLogout}
        />
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4">
              <div className="profile-card">
                {customerData[0]?.fld_created_on && (
                  <div className="d-flex pb-0 justify-content-end">
                    <p className="mb-0">
                      Customer Since: {customerData[0]?.fld_created_on}
                    </p>
                  </div>
                )}
                <div className="d-flex pt-0">
                  <div className="img">
                    <img
                      alt=""
                      src="https://store.bechofy.in/images/Beads_Beauty/ProductImages/215493-No_Image_Available-2.webp"
                      className="img-fluid"
                    />
                    {/* <div className="fields">
                      <lable>Date of Birth</lable>
                      <p>01-01-2000</p>
                    </div> */}
                  </div>
                  <div className="content">
                    <div className="fields">
                      <lable>Name</lable>
                      <p>{customerData[0]?.fld_name}</p>
                    </div>
                    {customerData[0]?.fld_dateofbirth && (
                      <div className="fields">
                        <lable>Date of Birth</lable>
                        <p>{customerData[0]?.fld_name}</p>
                      </div>
                    )}
                    <div className="fields">
                      <lable>Email</lable>
                      <p>{customerData[0]?.fld_email_address}</p>
                    </div>
                  </div>
                </div>
                <div className="btns">
                  <button
                    onClick={() => {
                      setEditCustomerData(true);
                      setTempCustomerData(customerData);
                    }}
                  >
                    <FaUserEdit /> Edit
                  </button>
                  <button onClick={() => setOpenChangePwd(true)}>
                    <FaLockOpen /> Change Password
                  </button>
                  <button onClick={() => setCanLogout(true)}>
                    <FiLogOut /> Logout
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-4 mt-lg-0 col-lg-8">
              <div className="row h-100">
                <div className="col-md-6 col-lg-3 mb-4 mb-md-0">
                  <div className="four-card">
                    <div className="head">
                      <div className="icon">
                        <FaListUl />
                      </div>
                      Orders
                    </div>
                    <div className="fields">
                      <lable>No. of Orders:</lable>
                      <p>{totalOrders ? totalOrders.total_order : 0}</p>
                    </div>
                    <div className="fields">
                      <lable>Last Ordered on:</lable>
                      <p>{totalOrders?.fld_order_date}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="four-card">
                    <div className="head">
                      <div className="icon">
                        <GiReceiveMoney />
                      </div>
                      My Savings
                    </div>
                    <div className="fields">
                      <lable>Spent: </lable>
                      <p>
                        <LuIndianRupee />{" "}
                        {totalOrders
                          ? parseFloat(totalOrders?.TotalSalesValue).toFixed(2)
                          : 0}
                      </p>
                    </div>
                    <div className="fields">
                      <lable>Saved: </lable>
                      <p>
                        <LuIndianRupee />{" "}
                        {totalOrders
                          ? parseFloat(totalOrders?.total_discount).toFixed(2)
                          : 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CustomerOrderList />
            <div className="col-12 mb-4">
              <div className="d-flex justify-content-between mb-4 align-items-end">
                <h2 className="mb-0">Address</h2>
                <button
                  className="theme-btn border-0"
                  onClick={() => {
                    setShowCanvas(true);
                  }}
                >
                  Add Address
                </button>
              </div>

              {addressData.length === 0 ? (
                <div className="w-100 text-center address-not-found">
                  {/* <img className="nodata-icon" src={nodata} /> */}
                  <img src={NoAddress} />
                  <p className="text-center my-2 fs-5 fw-bold">
                    No address found
                  </p>
                </div>
              ) : (
                <Swiper
                  slidesPerView={1}
                  spaceBetween={10}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  modules={[Pagination]}
                  className="mySwiper pb-5"
                >
                  {addressData.map((address, index) => {
                    return (
                      <SwiperSlide>
                        <div className="address-card position-relative d-flex">
                          {/* <p className="fw-bold">Vishnu</p> */}
                          {/* <p>{address.fld_address_type} <br /></p> */}
                          <p>
                            <b>{address.fld_address_type}</b> <br />
                            {address.fld_address_1}, {address.fld_address_2},{" "}
                            <br />
                            {address.CityName}, {address.StateName} <br />{" "}
                            {address.fld_pincode}, {address.CountryName}
                          </p>
                          <p>{address.fld_landmark}</p>
                          <div className="address-edit-delete-btns">
                            <span
                              onClick={() => {
                                setTempAddData(address);
                                setShowCanvas(true);
                              }}
                            >
                              <MdEdit />
                            </span>
                            <span onClick={() => showDeleteModal(address)}>
                              <MdDeleteForever />
                            </span>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              )}
            </div>
            <div className="col-12 mb-4">
              <h2 className="mb-4">Frequently Bought Items</h2>

              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                  },
                }}
                modules={[Pagination]}
                className="mySwiper pb-5"
              >
                {apiData.length > 0 ? (
                  apiData.slice(0, 5).map((val, index) => {
                    const isInCart = cartItems.find((item) => {
                      if (item.fld_variantid === val.fld_variantid) {
                        return item;
                      }
                    });
                    return (
                      <SwiperSlide>
                        <div key={index} className="frequently-card">
                          <ProductCard1 productData={val} isInCart={isInCart} />
                        </div>
                      </SwiperSlide>
                    );
                  })
                ) : (
                  <div className="row w-100 mx-0 exclusive-offers-box">
                    <div className={`exclusive-offers-card mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`exclusive-offers-card mb-4 mb-lg-0 d-none d-lg-block`}
                    >
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`exclusive-offers-card mb-4 mb-lg-0 d-none d-lg-block`}
                    >
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`exclusive-offers-card mb-4 mb-lg-0 d-none d-lg-block`}
                    >
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`exclusive-offers-card mb-4 mb-lg-0 d-none d-lg-block`}
                    >
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      {/* Canva To Add Address */}
      <Offcanvas
        show={showCanvas}
        onHide={handleToggleCanvas}
        className="address-offcanvas"
        id="offcanvasNavbar-expand-lg"
        aria-labelledby="offcanvasNavbarLabel-expand-sm"
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <h4 className="section-title-category-section mt-0">
            Add New Address
          </h4>
          {/* <img src={logo} className="img-fluid nav-logo" /> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <AddressBookForm
            toggleCanvas={handleToggleCanvas}
            address={tempAddData}
          />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Canvas to edit profile data */}
      <Offcanvas
        show={editCustomerData}
        onHide={handleToggleCustomerProfile}
        className="address-offcanvas"
        id="offcanvasNavbar-expand-lg"
        aria-labelledby="offcanvasNavbarLabel-expand-sm"
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <h4 className="section-title-category-section mt-0">Edit Profile</h4>
          {/* <img src={logo} className="img-fluid nav-logo" /> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <EditProfile
            toggleCanvas={handleToggleCustomerProfile}
            customerData={tempCustomerData}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Modal centered show={showDeleteAdd} onHide={hideDeleteAdd}>
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="login-box pb-0">
            {/* <div className="login-modal-icon">
              <LuLogOut />
            </div> */}
            <div className="section-title mb-0 mt-0">
              <h4 className="text-center">Delete address</h4>
            </div>
            <p style={{ textAlign: "center", marginTop: "-10px" }}>
              Are you sure you want to Delete Address?
            </p>

            <div className="text-center">
              <button className="theme-btn border-0 me-3" onClick={handleDeleteAdd}>
                Yes
              </button>
              <button className="theme-btn border-0" onClick={hideDeleteAdd}>
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
